function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as o } from "./index.es33.js";
import { useState as c, useRef as R, useEffect as S, useMemo as v, useCallback as w } from "react";
import { clsx as A } from "./index.es105.js";
import { useClickAway as D } from "./index.es130.js";
import { Search as N } from "./index.es65.js";
import P from "./index.es214.js";
import T from "./index.es215.js";
import { DEFAULT_CATEGORY as _, GROUPED_EMOJIS as H, EMOJI_FOCUS_KEY_CODE as K } from "./index.es216.js";
import { useDebounce as M, useRecent as U } from "./index.es217.js";
import { Positions as j } from "./index.es218.js";
import { createClassNamePosition as F } from "./index.es219.js";
import n from "./index.es220.js";

var G = function G(_ref) {
  var _ref$position = _ref.position,
      E = _ref$position === void 0 ? j.topLeft : _ref$position,
      g = _ref.onEmojiClick,
      x = _ref.children;

  var _c = c(!1),
      _c2 = _slicedToArray(_c, 2),
      i = _c2[0],
      a = _c2[1],
      _c3 = c(_),
      _c4 = _slicedToArray(_c3, 2),
      t = _c4[0],
      m = _c4[1],
      _c5 = c(""),
      _c6 = _slicedToArray(_c5, 2),
      l = _c6[0],
      f = _c6[1],
      u = R(null),
      r = M(l),
      _U = U(g),
      p = _U.recent,
      C = _U.onEmojiChooseHandler;

  S(function () {
    r.length && t && m(null);
  }, [r, t]);
  var d = v(function () {
    var e = H;
    return r.length ? {
      "Searching results": Object.values(e).flat().filter(function (h) {
        return h.tags.some(function (b) {
          return b.includes(r);
        });
      })
    } : (e = _objectSpread({
      Recent: p
    }, e), t === "Recent" ? e : t ? _defineProperty({}, t, e[t]) : e);
  }, [r, t, p]);
  D(u, function () {
    i && a(!1);
  });

  var k = w(function (e) {
    f(""), m(e);
  }, []),
      y = function y(e) {
    var s = e.target;
    C(s);
  },
      O = function O(e) {
    if (e.code === K) {
      var s = e.target;
      C(s);
    }
  };

  return o.jsxs("div", {
    className: n.container,
    children: [o.jsx("button", {
      className: n.button,
      onClick: function onClick() {
        return a(!i);
      },
      children: x
    }), i && o.jsxs("div", {
      className: A(n.pickerWrapper, F(E)),
      ref: u,
      children: [o.jsx(N, {
        value: l,
        onChange: f,
        isError: !1
      }), o.jsx(P, {
        current: t,
        setCurrent: k
      }), o.jsx("div", {
        className: n.emojiContainer,
        onClick: y,
        onKeyDown: O,
        children: Object.keys(d).map(function (e) {
          return o.jsx(T, {
            name: e,
            data: d[e]
          }, e);
        })
      })]
    })]
  });
};

G.PositionVariants = j;
export { G as EmojiPicker };